import { useSuspenseQuery } from '@tanstack/react-query';

import {
  listMutualDuosKey,
  type ListMutualDuosKeyParams,
  listMutualDuosOptions,
} from './listMutualDuos.options';

export function useListMutualDuos(params: ListMutualDuosKeyParams) {
  return useSuspenseQuery(listMutualDuosOptions(params));
}

useListMutualDuos.getQueryKey = listMutualDuosKey;
